import React from "react";
import { Link } from "react-router-dom";
import { Container, UncontrolledTooltip, Row, Card, Col, Input } from "reactstrap";
import NoImage from "../../../assets/images/no_image.png";
import TableComponent from "../../../components/Common/TableComponent";
import { getUsers, deleteUser, upateUserStatus } from "../../../services/userService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import PaginationComponent from "../../../components/Common/Pagination";
import Switch from "react-switch";
import SweetAlert from "react-bootstrap-sweetalert";


class Users extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 0,
            search: "",
            limit: 25,
            sort:"user_id",
            asc:false,
            total_count: 0,
            users: [],
            alertModel: false,
            alertMessage: "",
            loading: false
        };

        this.changePage = this.changePage.bind(this);
        this.removeCustomer = this.removeCustomer.bind(this);
    }

    changePage(pageNumber) {

        this.setState({ page: pageNumber });

        const req = {
            offset: pageNumber,
            limit: this.state.limit,
            search: this.state.search,
            sort: this.state.sort,
            asc: this.state.asc
        };

        this.setState({ loading: true });

        getUsers(req)
        .then(response => {
            this.setState({ loading: false });
            const { data } = response;
            // console.log(response)
            if(data.status)
            {
                this.setState({
                    users: data.users,
                    total_count: data.totalCount
                });
            } else {
                notifyError(data.message);
            }

        });
    }
    removeCustomer(id) {
        deleteUser(id)
        .then(res => {
            const { data } = res;
            if(data.status){
                notifySuccess(data.message);
                this.changePage(0);
            }  else {
                notifyError(data.message);
            
            }
        });
    }

    changeStatus(id, status) {
        upateUserStatus(id, {is_active: status})
        .then(response => {
            const { data } = response;
            if(data.status) {
                notifySuccess(data.message);
                setTimeout(() => this.changePage(0) , 2000);
            } else {
                notifyError(data.message);
            }   
        });
        
    }


    applySort = key => {
       if(this.state.sort === key)
       {
           this.setState({asc: !this.state.asc}, () => this.changePage(0));
       } else {
           this.setState({sort: key, asc: true}, () => this.changePage(0));
       }
    }

    componentDidMount() {
        this.changePage(0);
    }

    render() {
        const columns = [
            // {
            //     Header: "No.",
            //     accessor: "_id",
            //     Cell: ({row}) => (this.state.page * 20) + (row.index + 1)
            // },
            {
                Header: () => "User Id" ,
                accessor: "user_id",
                sortable : true,
                Cell: ({row}) => <span>{row.original.user_id}</span>,
            },
            {
                Header: "Avtar",
                accessor: "avtar",
                Cell: ({row}) => <img src={row.original.avatar ?  `${row.original.avatar}` : NoImage} height="50px" width="50px" alt="Not available" />
            },
            {
                Header: "Name",
                accessor: "first_name",
                sortable: true,
                Cell: ({row}) => {
                    return (
                        <>
                            <span>{`${row.original.first_name || "NA"} ${row.original.last_name}`}</span> 
                        </>
                    )
                }
            },
            {
                Header: "Job Title",
                accessor: "job_title",
                sortable:true,
                Cell: ({row}) => <span> {row.original.job_title ? row.original.job_title : "NA" }</span> 
            },
            {
                Header: "Gender",
                accessor: "gender",
                sortable: true,
                Cell: ({row}) => <span> {row.original.gender || "NA"}</span> 
            },
            {
                Header: "Active",
                accessor: "active",
                // sortable: true,
                Cell: ({row}) => 
                    <>  
                        <Switch
                            uncheckedIcon={<span>&#160;</span>}
                            checkedIcon={<span>&#160;</span>}
                            // onColor="#626ed4"
                            onColor="#02a499"
							offColor="#ec4561"
                            onChange={() => this.changeStatus(row.original.user_id, !row.original.is_active)}
                            checked={row.original.is_active}
                            className="mr-1 mt-1"
                        />
                    </>
                
            },
            {
                Header: "Action",
                Cell: ({row}) => 
                    <>
                        <Link to={`/users/view/${row.original.user_id}`} className="mr-3 text-primary" id="edit6"><i className="mdi mdi-eye font-size-18"></i></Link>
                        <UncontrolledTooltip placement="top" target="edit6">
                            View
                        </UncontrolledTooltip >

                        <Link to={`/users/edit/${row.original.user_id}`} className="mr-3 text-info" id={`edit_${row.original.user_i}`}><i className="fa fa-edit font-size-18"></i></Link>
                        <UncontrolledTooltip placement="top" target={`edit_${row.original.user_i}`}>
                            Edit
                        </UncontrolledTooltip >

                        {/* <span id={`delete_${row.original.user_id}`}><i className="text-danger fas fa-trash" onClick={e => {
                            this.setState({
                                confirmModal: true,
                                user: row.original
                            })
                        }}></i></span>
                        <UncontrolledTooltip placement="top" target={`delete_${row.original.user_id}`}>
                            Delete
                        </UncontrolledTooltip > */}

                    </>
            }
        ];

        return (
            <React.Fragment>
                <div className="page-content">

                    <Container fluid>
                          
                        <Card>
                            <h3 className="p-3">
                                Users
                            </h3>
                            <hr/>
                            <Row className="p-2">
                                <Col lg={6} md={6} sm={4} xs={4}>
                                    <Link
                                        className="ml-1 btn btn-info btn-md"
                                        to={"/users/add"}
                                    >
                                     <i className="fas fa-plus"></i>   Add 
                                    </Link>
                                </Col>

                                <Col lg={6} md={6} sm={7} xs={7}>
                                    <div className="form-inline float-md-right">
                                        <div className="search-box ml-2">
                                            <div className="position-relative">
                                                <Input
                                                    onChange={e => {                                                        
                                                        this.setState(
                                                            { search: e.target.value },
                                                            () => this.changePage(0)
                                                          );
                                                    }}
                                                    bsSize="lg"
                                                    type="text"
                                                    name="search"
                                                    value={this.state.search}
                                                    className="form-control rounded"
                                                    placeholder="Name, Job Title, User Id"
                                                />
                                                <i className="mdi mdi-magnify search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <div className="table-responsive mt-2 p-1 scrollbar" style={{overflowY:"auto", "height": "1000px"}}>
                                <TableComponent
                                    columns={columns}
                                    data={this.state.users}
                                    sort={this.state.sort}
                                    asc={this.state.asc}
                                    applySort={this.applySort}
                                    loading={this.state.loading}
                                />
                            </div>
                            <div style={{"position":"absolute","bottom":"10px","width":"100%","zIndex":"99999", "backgroundColor": "white"}}>
                            {
                                this.state.total_count > 0 ?
                                <PaginationComponent
                                    total_count={this.state.total_count}
                                    page={this.state.page}
                                    limit={this.state.limit}
                                    changePage={this.changePage}
                                    changeFilter={e => {
                                        this.setState({ limit: e.target.value }, () => this.changePage(0));
                                    }}
                                /> : ""
                            }
                            </div>
                        </Card>
                    </Container>
                   
                    {
                        this.state.confirmModal &&
                    
                        <SweetAlert
                            title="Are you sure?"
                            warning
                            showCancel  
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            onConfirm={() =>{
                                this.setState({
                                    confirmModal: false
                                });

                                this.removeCustomer(this.state.user.user_id);

                            }}
                            onCancel={() => {
                                this.setState({
                                    confirmModal: false,
                                    user: null
                                })
                            }}
                        >
                            <span className="text-danger"><strong>Delete</strong> </span> <strong>{`${this.state.user.first_name} ${this.state.user.last_name}`}</strong>
                        </SweetAlert>
                    } 
                </div>
            </React.Fragment>
        )
    }
}
export default Users;